module.exports = __webpack_public_path__ + "img/receipt24.d8263d29.png";